var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9736 12.6094L11.9757 12.6066C12.1571 12.3954 12.2471 12.1208 12.2261 11.8432C12.205 11.5657 12.0745 11.3078 11.8633 11.1264C11.7588 11.0366 11.6376 10.9683 11.5066 10.9253C11.3756 10.8824 11.2374 10.8656 11.1 10.8761C10.8224 10.8971 10.5646 11.0276 10.3832 11.2388L6.2217 15.9827L4.9211 14.6814C4.82361 14.5839 4.70788 14.5066 4.5805 14.4538C4.45313 14.401 4.31661 14.3739 4.17875 14.3739C4.04088 14.3739 3.90436 14.401 3.77699 14.4538C3.64962 14.5066 3.53388 14.5839 3.4364 14.6814C3.33891 14.7789 3.26158 14.8946 3.20882 15.022C3.15606 15.1493 3.12891 15.2859 3.12891 15.4237C3.12891 15.5616 3.15606 15.6981 3.20882 15.8255C3.26158 15.9529 3.33891 16.0686 3.4364 16.1661L5.5357 18.2661C5.738 18.4691 6.0082 18.5741 6.3057 18.5734H6.319C6.46337 18.5678 6.60503 18.5324 6.73511 18.4695C6.8652 18.4067 6.9809 18.3176 7.075 18.208L11.9736 12.6094Z",
    fill: "#108043",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickicon);
export default __webpack_public_path__ + "static/media/tickicon.74c118f21578389fef7e8a2fc830eef7.svg";
export { ForwardRef as ReactComponent };